import moment from "moment";
// Generate data for the weeks

export const months = Array.from({ length: 12 }, (_, index) => ({
  name: `${moment().month(index).format("MMMM")}`,
  monthName: moment().month(index).format("MMMM"),
  label: String(index + 1),
}));
